import CheckBox from "devextreme-react/check-box";
import DataGrid from "devextreme-react/data-grid";
import Toolbar from "devextreme-react/toolbar";
import { Column, ColumnFixing, Editing, FilterPanel, FilterRow, HeaderFilter, Pager, Paging, Sorting } from 'devextreme-react/data-grid';
import { Item } from 'devextreme-react/toolbar';
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Transition } from "semantic-ui-react";
import { Button } from '../../components/buttons';
import { ComboboxHe } from '../../components/combobox-he';
import ComboboxKhoi from '../../components/combobox-khoi';
import { ComboboxTruong } from '../../components/combobox-truong';
import { AnimationConfirm } from '../../components/confirm';
import { localStorageHelper } from '../../helpers/localStorage';
import { PageBaseStatus } from '../../models/pageBaseStatus';
import { ganMienGiamFilterStudentModel } from '../../models/request/gan-mien-giam/ganMienGiamFilterStudent';
import { sf_dexuatmiengiam_changed_rq } from '../../models/request/gan-mien-giam/sf_dexuatmiengiam_changed_rq';
import { approveGanMienGiamCancel, approveGanMienGiamSubmit, changeGanMienGiamFilterStudent, changeGanMienGiamStart, changeHe, changeHinhThucMienGiam, changeKhoi, changeNhomMienGiam, changeTruong, closeGanMienGiamFilterStudentModal, closeGanMienGiamImportModal, loadGanMienGiamHinhThucMienGiamStart, loadGanMienGiamHocSinhStart, loadGanMienGiamStart, showGanMienGiamImportModal } from '../../state/actions/ganMienGiamActions';
import { RootState } from '../../state/reducers';
import { GanMienGiamFilterStudentModal } from './filter-student-modal';
import { GanMienGiamImportModal } from './import-modal/GanMienGiamImportModal';
import ComboBoxNhomMienGiam from "../../components/combobox-nhommiengiam";
import TagBoxHinhThucMienGiam from "../../components/tagbox-hinh-thuc-mien-giam";
import { TextBox } from "devextreme-react";
import { Box } from "@primer/react";
import styles from "./GanMienGiamPage.module.css";
import { useCommonContext } from "../../contexts/common";
import { SF_DEXUATMIENGIAM_CHANGED } from "../../api/ganMienGiamApi";


const GanMienGiamPage = () => {
    const state = useSelector((x: RootState) => x.ganMienGiam)
    const grid = useRef<any>();
    const dispatch = useDispatch();
    const { nam_hoc, dm_coso_id } = useSelector((x: RootState) => x.common)
    const [ma_hs, set_ma_hs] = useState<string>('');
    const { checkAccesiableToV2 } = useCommonContext();

    const {
        //filter,
        is_show_filter_student_modal,
        filterStudent,
        sf_dexuatmiengiams,
        status,
        ts_hocsinhs,
        approve_request,
        is_show_approve_confirm,
        is_show_import_modal,
        dm_he_id,
        dm_khoi_id,
        dm_truong_id,
        nhom_mien_giam_id,
        hinh_thuc_mien_giam_ids
    } = state;
    const sf_hinhthucmiengiams = useMemo(() => {
        return state.sf_hinhthucmiengiams
    }, [state.sf_hinhthucmiengiams, dm_coso_id])
    //const { nam_hoc } = filter;
    const ts_hocsinh_ids = useMemo(() => {
        return ts_hocsinhs.map(x => x.id);
    }, [ts_hocsinhs])


    const isAccessibleUpdate = useMemo(() => {
        debugger
        if (!checkAccesiableToV2(SF_DEXUATMIENGIAM_CHANGED, 'POST')) return false;
        return true;
    }, [checkAccesiableToV2]);



    useEffect(() => {
        if (status === PageBaseStatus.is_loading) {
            grid.current.instance.beginCustomLoading();
        } else {
            grid.current.instance.endCustomLoading();
        }
    }, [status]);

    useEffect(() => {
        if (nam_hoc !== "") {
            dispatch(loadGanMienGiamHinhThucMienGiamStart(nam_hoc))
        }
    }, [nam_hoc]);

    useEffect(() => {
        dispatch(loadGanMienGiamHocSinhStart({
            dm_he_id: dm_he_id,
            dm_khoi_id: dm_khoi_id,
            dm_truong_id: dm_truong_id,
            nam_hoc: nam_hoc
        }))
        dispatch(loadGanMienGiamStart({
            dm_he_id: dm_he_id,
            dm_khoi_id: dm_khoi_id,
            dm_truong_id: dm_truong_id,
            nam_hoc: nam_hoc
        }))
        localStorageHelper.setNamHocTruongKhoiFilter({
            dm_he_id: dm_he_id !== undefined ? dm_he_id : 0,
            dm_khoi_id: dm_khoi_id !== undefined ? dm_khoi_id : 0,
            dm_truong_id: dm_truong_id !== undefined ? dm_truong_id : 0,
            nam_hoc: nam_hoc
        })
    }, [dm_he_id, dm_khoi_id, dm_truong_id, nam_hoc]);

    useEffect(() => {
        if (status === PageBaseStatus.is_need_reload)
            dispatch(loadGanMienGiamStart({
                dm_he_id: dm_he_id,
                dm_khoi_id: dm_khoi_id,
                dm_truong_id: dm_truong_id,
                nam_hoc: nam_hoc
            }))

    }, [status]);


    const handleApprove = async (sf_hinhthucmiengiam_id: number, is_approved: boolean) => {
        dispatch(approveGanMienGiamSubmit({
            dm_he_id: dm_he_id,
            dm_khoi_id: dm_khoi_id,
            dm_truong_id: dm_truong_id,
            nam_hoc: nam_hoc,
            is_approved: is_approved,
            sf_hinhthucmiengiam_id: sf_hinhthucmiengiam_id,
            ts_hocsinh_ids: ts_hocsinh_ids

        }))
    }
    const handleExport = useCallback(() => {
        if (grid && grid.current && grid.current.instance) {
            grid.current.instance.exportToExcel();
        }
    }, [grid])

    const renderTitleHeader = useCallback((data: any) => {
        let sf_hinhthucmiengiam_id = parseInt(data.column.name.replace("M_", "")) || 0
        const length_hinh_thuc_mien_giam = sf_dexuatmiengiams.filter(c => c.sf_hinhthucmiengiam_id === sf_hinhthucmiengiam_id).length;
        return (
            <span>
                {data.column.caption + ' (' + length_hinh_thuc_mien_giam + ')'}
            </span>
        );

    }, [sf_dexuatmiengiams, ts_hocsinh_ids])
    const HandleValueChanged = async (data: sf_dexuatmiengiam_changed_rq) => {
        dispatch(changeGanMienGiamStart(data))
    }

    const onlyUnique = (value: any, index: any, self: any) => {
        return self.indexOf(value) === index;
    }
    const dynamicColumns = useMemo(() => {
        let sf_hinhthucmiengiams_temp = sf_hinhthucmiengiams;
        if (hinh_thuc_mien_giam_ids.length > 0) {
            sf_hinhthucmiengiams_temp = sf_hinhthucmiengiams_temp.filter((x: any) => hinh_thuc_mien_giam_ids.includes(x.id));
        }
        return sf_hinhthucmiengiams_temp.filter(c => c.dm_coso_id === dm_coso_id && (nhom_mien_giam_id === 0 || c.nhom_mien_giam === nhom_mien_giam_id)).map(x => x.nhom_mien_giam).filter(onlyUnique).map(nhom_mien_giam => {
            const sf_hinhthucmiengiams_nhom = sf_hinhthucmiengiams_temp.filter(x => x.nhom_mien_giam === nhom_mien_giam && x.dm_coso_id === dm_coso_id);
            return (
                <Column key={nhom_mien_giam} alignment="center" caption={"Nhóm " + nhom_mien_giam} >
                    {sf_hinhthucmiengiams_nhom.map(x => {
                        //const length_hinh_thuc_mien_giam = sf_dexuatmiengiams.filter(c => c.sf_hinhthucmiengiam_id === x.id).length;
                        return (
                            <Column key={x.id} dataField={"M_" + x.id}
                                caption={x.ma_hinh_thuc}
                                width={100}
                                cellRender={(cell) => {
                                    if (cell.data["M_" + x.id] === true) {
                                        return <CheckBox value={true} />
                                    }
                                    if (x.so_lan_huong_toi_da > 1 && cell.data["M_" + x.id] > 0) {
                                        return <span>{cell.data["M_" + x.id]}</span>
                                    }
                                    return (
                                        <span></span>
                                    );
                                }}
                                setCellValue={(newData: any, value: any, currentRowData: any) => {
                                    {
                                        isAccessibleUpdate &&
                                            handleSetCellValue(newData, value, currentRowData, "M_" + x.id)
                                    }
                                }}

                                allowSorting={false}
                                headerCellRender={(cell: any) => {
                                    return renderTitleHeader(cell)
                                }}

                                allowFiltering={false}
                                dataType={x.so_lan_huong_toi_da > 1 ? "number" : "boolean"}
                            />
                        );
                    })}
                </Column>
            );
        })

    }, [sf_dexuatmiengiams, sf_hinhthucmiengiams, nhom_mien_giam_id, hinh_thuc_mien_giam_ids])
    const handleSetCellValue = async (newData: any, value: any, currentRowData: any, fieldName: string) => {

        const sf_hinhthucmiengiam_id = parseInt(fieldName.replace("M_", "")) || 0
        let is_selected: boolean = false;
        let so_lan_ap_dung: number = 1;
        if (typeof value == "number") {
            is_selected = value > 0;
            so_lan_ap_dung = value;
        }
        if (typeof value == "boolean") {
            is_selected = value;
            so_lan_ap_dung = 1;
        }
        HandleValueChanged({
            nam_hoc: nam_hoc,
            ts_hocsinh_id: currentRowData.id,
            sf_hinhthucmiengiam_id: sf_hinhthucmiengiam_id,
            is_selected: is_selected,
            so_lan_ap_dung: so_lan_ap_dung
        });

    }
    const dataSource = useMemo(() => {
        let ts_hocsinhs_temp = ts_hocsinhs;
        if (ma_hs !== '') {
            ts_hocsinhs_temp = ts_hocsinhs_temp.filter((x: any) => x.ma_hs.includes(ma_hs) || x.ho_ten.includes(ma_hs) || x.ho_ten.includes(ma_hs.toUpperCase() || x.ma_hs.includes(ma_hs.toUpperCase())))
        }
        let sf_hinhthucmiengiams_temp = sf_hinhthucmiengiams;
        const result = ts_hocsinhs_temp.map(x => {
            const sf_dexuatmiengiam_hocsinhs = sf_dexuatmiengiams.filter(y => y.ts_hocsinh_id === x.id);
            // console.log(sf_hinhthucmiengiams)
            let item: any = {
                id: x.id,
                ma_hs: x.ma_hs,
                ho_ten: x.ho_ten,
                ngay_sinh: x.ngay_sinh,
                trang_thai: x.dm_trangthaihocsinh_trang_thai,
                ten_truong: x.ten_truong,
                ten_khoi: x.ten_khoi,
                ten_he: x.ten_he
            };
            let summary: string[] = [];
            sf_hinhthucmiengiams_temp.forEach(x => {
                if (x.so_lan_huong_toi_da <= 1) {
                    item["M_" + x.id] = false;
                }
            })
            for (let i = 0; i < sf_dexuatmiengiam_hocsinhs.length; i++) {
                const sf_hinhthucmiengiam_id = sf_dexuatmiengiam_hocsinhs[i].sf_hinhthucmiengiam_id;
                const so_lan_ap_dung = sf_dexuatmiengiam_hocsinhs[i].so_lan_ap_dung;
                const sf_hinhthucmiengiam = sf_hinhthucmiengiams_temp.find(x => x.id === sf_hinhthucmiengiam_id);
                item = Object.assign({}, item, { ["M_" + sf_hinhthucmiengiam_id]: sf_hinhthucmiengiam?.so_lan_huong_toi_da === 1 ? true : so_lan_ap_dung });

                summary.push(
                    sf_hinhthucmiengiam
                        ? so_lan_ap_dung > 1
                            ? `[${so_lan_ap_dung} lần] x ${sf_hinhthucmiengiam.hinh_thuc_mien_giam}`
                            : `${sf_hinhthucmiengiam.hinh_thuc_mien_giam}\n`
                        : ""
                );

            }
            item = Object.assign({}, item, { summary: summary.join('\n') })
            return item;
        });
        return result;

    }, [ts_hocsinhs, sf_dexuatmiengiams, sf_hinhthucmiengiams, nhom_mien_giam_id, hinh_thuc_mien_giam_ids, ma_hs])
    return (
        <Box className={styles.container} sx={{ p: 2 }}>
            <Transition animation="scale"
                visible={true}
                duration={100}
                transitionOnMount={true}>
                <div className='row'>
                    <div className="col-md-12 page-toolbar">
                        <Toolbar className="bg-background">
                            <Item location="before">
                                <ComboboxTruong
                                    value={dm_truong_id}
                                    onValueChanged={(value) => {
                                        dispatch(changeTruong(value))
                                    }}
                                    isShowClearButton={true}

                                />
                            </Item>
                            <Item location="before">
                                <ComboboxKhoi
                                    dm_truong_id={dm_truong_id}
                                    value={dm_khoi_id}
                                    width={150}
                                    onValueChanged={(value) => {
                                        dispatch(changeKhoi(value))
                                    }}
                                />
                            </Item>
                            <Item location="before">
                                <ComboboxHe
                                    width={150}
                                    dm_khoi_id={dm_khoi_id}
                                    dm_truong_id={dm_truong_id}
                                    value={dm_he_id}
                                    onValueChanged={(value) => {
                                        dispatch(changeHe(value))
                                    }}
                                />

                            </Item>
                            <Item location="before">
                                <TextBox
                                    value={ma_hs}
                                    stylingMode="outlined"
                                    width={190}
                                    height={34}
                                    placeholder="Học sinh"
                                    onValueChanged={(e) => {
                                        set_ma_hs(e.value);
                                    }}
                                ></TextBox>
                            </Item>
                            <Item location="before">
                                <ComboBoxNhomMienGiam
                                    isShowClearButton={true}
                                    dataSource={sf_hinhthucmiengiams}
                                    value={nhom_mien_giam_id}
                                    onValueChanged={(value) =>
                                        dispatch(changeNhomMienGiam(value === null ? 0 : value))
                                    }
                                />
                            </Item>
                            <Item location="before">
                                <TagBoxHinhThucMienGiam
                                    width={500}
                                    nhom_mien_giam={nhom_mien_giam_id}
                                    isShowClearButton={true}
                                    dataSource={sf_hinhthucmiengiams}
                                    value={hinh_thuc_mien_giam_ids}
                                    onValueChanged={(value) => {
                                        dispatch(changeHinhThucMienGiam(value === null ? [] : value))
                                    }}

                                />
                            </Item>
                            <Item location="after"
                                locateInMenu="never">
                                <Button
                                    type="normal"
                                    icon="fas fa-redo"
                                    text="Refresh"
                                    id='btnRefresh'
                                    onClick={() => {
                                        dispatch(loadGanMienGiamStart({
                                            dm_he_id: dm_he_id,
                                            dm_khoi_id: dm_khoi_id,
                                            dm_truong_id: dm_truong_id,
                                            nam_hoc: nam_hoc
                                        }))
                                    }}
                                />{' '}
                                {isAccessibleUpdate &&
                                    <Button
                                        id='btnImport'
                                        type="normal"
                                        icon="fas fa-file-excel"
                                        text={`Import`}
                                        onClick={() => {
                                            dispatch(dispatch(showGanMienGiamImportModal()));
                                        }}
                                    />
                                }
                                <Button type="normal" icon="fas fa-file-excel" text="Export" onClick={handleExport} />
                            </Item>
                        </Toolbar>
                    </div>

                    <div className="col-md-12" style={{ paddingTop: '5px' }}>
                        <DataGrid
                            ref={grid}
                            keyExpr="id"
                            dataSource={dataSource}
                            columnHidingEnabled={false}
                            remoteOperations={false}
                            columnAutoWidth={true}
                            showBorders={true}
                            showColumnLines={true}
                            showRowLines={true}
                            rowAlternationEnabled={true}
                            allowColumnResizing={true}
                            columnResizingMode={"nextColumn"}
                            hoverStateEnabled={true}
                            focusedRowEnabled={false}
                            height={window.innerHeight - 240}
                            className="table table-bordered table-hover "
                            noDataText="Không có dữ liệu"
                            wordWrapEnabled={true}
                            loadPanel={{ enabled: false }}

                        // paging={{ enabled: true }}

                        >
                            {/* <Scrolling mode="infinite" /> */}
                            <Sorting mode="multiple" />
                            <Paging defaultPageSize={20}
                                enabled
                            />
                            {/* <Selection mode="single" /> */}
                            <Editing
                                mode="cell"
                                allowUpdating={true}
                                allowAdding={false}
                                allowDeleting={false} />
                            <FilterRow visible={true} />
                            <FilterPanel visible={false} />
                            <HeaderFilter visible={true} />.

                            <ColumnFixing enabled={false} />


                            <Column dataField="trang_thai" caption="Trạng thái" fixed width={100} allowEditing={false} />
                            <Column dataField="ma_hs" caption="Mã HS" fixed width={150} allowEditing={false} />
                            <Column dataField="ho_ten" caption="Họ tên" fixed width={200} allowEditing={false} />
                            <Column dataField="summary" caption="Đã áp dụng" fixed width={180} allowEditing={false} />
                            <Column alignment="center" caption="Hình thức miễn giảm" >
                                {dynamicColumns}

                            </Column>
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={[20, 50, 100]}
                                infoText="Trang {0} /{1} ({2} dòng)"
                                showInfo={true} />
                        </DataGrid>
                    </div>
                    {is_show_filter_student_modal &&
                        <GanMienGiamFilterStudentModal
                            animationOf='#btnFilter'
                            filterStudent={filterStudent}
                            onClose={() => { dispatch(closeGanMienGiamFilterStudentModal()) }}
                            onSubmit={(filter: ganMienGiamFilterStudentModel) => {
                                dispatch(changeGanMienGiamFilterStudent(filter))
                                dispatch(closeGanMienGiamFilterStudentModal())
                            }}
                        />
                    }
                    {is_show_approve_confirm && approve_request && <AnimationConfirm
                        animationOf={`btnApprove${approve_request?.sf_hinhthucmiengiam_id}`}
                        onClose={() => { dispatch(approveGanMienGiamCancel()) }}
                        onConfirmed={() => { dispatch(approveGanMienGiamSubmit(approve_request)) }}
                        text={`Bạn có chắc chắn muốn ${approve_request.is_approved ? "áp dụng" : "bỏ áp dụng"} cho tất cả học sinh đang hiển thị`}
                        type={approve_request.is_approved ? "success" : "danger"}
                        is_saving={status === PageBaseStatus.is_saving}
                        icon="fas fa-tasks"
                        text_confirm_button={approve_request.is_approved ? "Áp dụng" : "Bỏ áp dụng"}

                    />
                    }
                    {is_show_import_modal &&
                        <GanMienGiamImportModal
                            nam_hoc={nam_hoc}
                            animationOf="#btnImport"
                            onClose={() => { dispatch(closeGanMienGiamImportModal()) }}
                            onSuccess={() => {
                                dispatch(closeGanMienGiamImportModal())
                                dispatch(loadGanMienGiamStart({
                                    dm_he_id: dm_he_id,
                                    dm_khoi_id: dm_khoi_id,
                                    dm_truong_id: dm_truong_id,
                                    nam_hoc: nam_hoc
                                }))
                            }}

                        />
                    }
                </div>
            </Transition>
        </Box>
    );
}
export default GanMienGiamPage;